;(function (root, factory, undef) {
	if (typeof exports === "object") {
		// CommonJS
		module.exports = exports = factory(require("./core"), require("./cipher-core"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));


//////////////////
// WEBPACK FOOTER
// ./~/crypto-js/mode-ecb.js
// module id = 126
// module chunks = 0 3 4 5 6 7 8 9 10 12 13 16 17 18 19 20 21 22 23 24 25 26 27 30 31 33 35 36 37 38 39 40 41 42 43 44 46 48 49 52 53 54 55 56 59 60 61 63 64 69 71 74 76 77 78 79 82 83 84 87 88 89 91 92 93 94 95 96 97 100 101 102 103 104 105 106 109 111 112 113 114 115 117 118 119 120 121 125 127 128 129 133 134 135 138 142 143 144 145 146 147 148 149 150 151 153 154 155 156 159 161 162 163 164 165 166 168 169 170 171 172 173 174